import React, { createRef } from "react";
import { TimelineLite } from "gsap";
import progress from "utils/progress";
import DownArrow from "../../svgs/DownArrow";
import tuv from "../../assets/images/tuv.svg";
import styles from "./indexVideo.module.scss";

const videoUrl = `${process.env.PUBLIC_URL}/files/videos/first-screen.mp4`;

export default class indexVideo extends React.PureComponent {
  boxRef = createRef();

  videoRef = createRef();

  componentDidMount() {
    const { tlCompleteCallback, tlReverseCompleteCallback } = this.props;
    this.tl = new TimelineLite({
      paused: true,
      onComplete: () => {
        tlCompleteCallback();
      },
      onReverseComplete: () => {
        tlReverseCompleteCallback();
      },
    });
    this.tl.to(this.boxRef.current, 1, {
      autoAlpha: 0.0,
    });
  }

  render() {
    const { title, downDesc, toSlidesManually, showLogo } = this.props;
    return (
      <div className="Main__section" ref={this.boxRef}>
        <div className="firstPage__intro">
          <div>
            <div>
              <div className="firstPage__desc">
                {title.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </div>
              {showLogo && (
                <div className="firstPage__logo">
                  <img src={tuv} alt="" />
                </div>
              )}
            </div>
            <span className="firstPage__link" onClick={toSlidesManually}>
              {downDesc}
              <div className="arrow_down">
                <DownArrow />
              </div>
            </span>
          </div>
        </div>
        <div className={styles.videoBox}>
          <div>
            <video
              className={styles.video}
              autoPlay="autoplay"
              muted="muted"
              src={`${process.env.PUBLIC_URL}/files/videos/first-screen.mp4`}
              preload="auto"
              loop="loop"
              ref={(el) => {
                this.videoRef = el;
              }}
              onCanPlayThrough={() => {
                console.log(
                  "onCanPlayThrough",
                  videoUrl,
                  this.videoRef.readyState,
                  this.videoRef.seekable.start(0),
                  this.videoRef.seekable.end(0)
                );
                progress(videoUrl);
              }}
              onProgress={() => {
                if (this.videoRef.buffered.length > 0) {
                  console.log(
                    "onProgress -->",
                    videoUrl,
                    this.videoRef.buffered.end(0),
                    this.videoRef.seekable.end(0)
                  );
                  progress(
                    videoUrl,
                    this.videoRef.seekable.end(0),
                    this.videoRef.buffered.end(0)
                  );
                }
              }}
            >
              <track default kind="captions" />
            </video>
          </div>
        </div>
      </div>
    );
  }
}
